import type { Scene } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { BaseSceneSwapBridge } from 'js/src/libs/scene-swapping/BaseBridge';
import { isVoiceDrivenSceneGroup } from 'js/src/luminary';

export class CommonToOrdinaryBridge extends BaseSceneSwapBridge {
    override _from = VideoData.CATEGORY_COMMON;
    override _to = VideoData.CATEGORY_ORDINARY;

    override _isSwapAllowedFor(originalScene: Scene): boolean {
        // you can swap a common scene to an ordinary scene if the common scene is being
        // used as a part of a ordinary scene group
        return !isVoiceDrivenSceneGroup(originalScene.sceneGroup!);
    }
}
